import { createContext } from 'react';

/** The asset owner resolves local references and owns their object URL lifetime. */
export interface ImageSourceResolver {
  canResolve(source: string): boolean;
  resolve(source: string): Promise<string | null>;
}

export const ImageSourceResolverContext =
  createContext<ImageSourceResolver | null>(null);
